<template>
  <component
    :is="hasTooltip ? 'm-tooltip' : 'div'"
    :placement="hasTooltip ? tooltipPlacement : undefined"
  >
    <m-card-item
      :focused="focused"
      class="m-select-item"
      no-hover
      @click="handleClick"
      @mouseover="$emit('focus')"
    >
      <div class="_item">
        <m-tag
          :title="!!$slots.default ? '' : item.label"
          :color="!!$slots.default || !tags ? 'none' : item.color"
          :automatic-color-fallback="automaticColor"
          :icon="item.icon"
          :style="triggerStyle"
          small
        >
          <template
            v-if="!!$slots.default"
            #default
          >
            <slot />
          </template>
        </m-tag>
      </div>
      <template
        v-if="selected"
        #right
      >
        <m-icon type="check" />
      </template>
    </m-card-item>
    <template #title>
      <slot name="tooltip" />
    </template>
  </component>
</template>

<script>
import MCardItem from 'shared/components/base/MCardItem.vue';
import MTextField from 'shared/components/base/MTextField.vue';
import MTooltip from 'shared/components/base/MTooltip.vue';

export default {
  name: 'MSelectItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    automaticColor: {
      type: Boolean,
      default: false,
    },
    triggerStyle: {
      type: Object,
      default: () => ({}),
    },
    tags: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
    hasTooltip: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['focus', 'click'],
  components: { MTooltip, MCardItem, MTextField },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .m-select-item {
    ._item {
      display: inline-flex;
      align-items: center;
      min-width: 0;
    }
  }
</style>
